import { getSharedWorkspaceContext } from './sharedWorkspace';

export function isPublicMode(): boolean {
  return (
    window.location.href.indexOf('/public') > 0 || !!getSharedWorkspaceContext()
  );
}
